export const getEnvs = () => ({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_API_URL_OFICINA_VIRTUAL: import.meta.env.VITE_API_URL_OFICINA_VIRTUAL,
  VITE_DRIVEAPI_URL: import.meta.env.VITE_DRIVEAPI_URL,
  VITE_NODE_ENV: import.meta.env.VITE_NODE_ENV,
  VITE_API_SOFTNET_URL: import.meta.env.VITE_API_SOFTNET_URL,

  //RADIUS
  VITE_RADIUS_URL: import.meta.env.VITE_RADIUS_URL,
  
  //AWS
  VITE_ACCESS_KEY_ID_AWS: import.meta.env.VITE_ACCESS_KEY_ID_AWS,
  VITE_SECRET_ACCESS_KEY_AWS: import.meta.env.VITE_SECRET_ACCESS_KEY_AWS,
  VITE_API_URL_AWS: import.meta.env.VITE_API_URL_AWS,
  VITE_BUCKET_BASE: import.meta.env.VITE_BUCKET_BASE as string,

  //SOCKET
  VITE_SOCKET_URL: import.meta.env.VITE_SOCKET_URL,

   //IMAGEN
  VITE_LOGO_EVA: import.meta.env.VITE_LOGO_EVA,
  VITE_FONDO_EVA: import.meta.env.VITE_FONDO_EVA,
  VITE_LOGO_EVA_DASHBOARD:  import.meta.env.VITE_LOGO_EVA_DASHBOARD,
});
